import { message } from 'antd';
import { generateSwitchKey, ERegisterType } from 'api/public';
import { closeManageSubscriptionModal } from 'utils/globalLayerControl';
import { PATH } from 'constants/path';
import { getSwitchAccountDomain } from 'utils/common';

/**
 * 处理账号切换逻辑
 * @param isKlarityAccount 是否为Klarity账号
 * @param onSwitchToAccount 切换账号前的回调函数（可选）
 * @returns Promise<boolean> 是否切换成功
 */
export const handleSwitchToAccount = async (
    isKlarityAccount: boolean = false,
    onSwitchToAccount?: () => void,
): Promise<boolean> => {
    try {
        // 调用POST接口获取generate-key
        const keyResult = await generateSwitchKey();

        if (keyResult.error) {
            message.error('Failed to generate switch key');
            return false;
        }

        const switchKey = keyResult.data?.data;

        if (!switchKey) {
            message.error('No switch key received');
            return false;
        }

        // 执行切换前的回调
        if (onSwitchToAccount) {
            onSwitchToAccount();
        }

        // 关闭管理订阅模态框
        closeManageSubscriptionModal();

        // 根据环境决定跳转方式
        const targetDomain = getSwitchAccountDomain(isKlarityAccount);
        if (targetDomain) {
            // 非localhost环境，跳转到对应域名并携带code参数
            window.location.href = `https://${targetDomain}${PATH.SWITCH_ACCOUNT_REDIRECT}?code=${switchKey}`;
        } else {
            // localhost环境，使用本地域名+ PATH.SWITCH_ACCOUNT_REDIRECT路径
            const currentHost = window.location.host;
            window.location.href = `http://${currentHost}${PATH.SWITCH_ACCOUNT_REDIRECT}?code=${switchKey}&accountType=${isKlarityAccount ? ERegisterType.KIWI_PORTAL : ERegisterType.KLARITY_PORTAL}`;
        }
        return true;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Switch account error:', error);
        message.error('An error occurred while switching account');
        return false;
    }
};
